export default "__VITE_ASSET__CkI6uTef__"